var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import colors from "../../designSystem/colors";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 8px;\n  height: 8px;\n  background-color: white;\n  border-radius: 4px;\n  margin-right: 8px;\n  overflow: hidden;\n  background-color: ", ";\n"], ["\n  width: 8px;\n  height: 8px;\n  background-color: white;\n  border-radius: 4px;\n  margin-right: 8px;\n  overflow: hidden;\n  background-color: ", ";\n"])), function (props) { return (props.connected ? colors.green : colors.red); });
var Indicator = function (_a) {
    var connected = _a.connected;
    return (_jsx(Container, { connected: connected }, void 0));
};
export default Indicator;
var templateObject_1;
//# sourceMappingURL=Indicator.js.map